export { default } from './HoldPosition';



// WEBPACK FOOTER //
// ./app/components/borrowing/HoldPosition/index.js